export const AllScreens = [
  { label: "Home", path: "/" },
  { label: "Initial Setup", path: "/initialsetup" },
  { label: "Login", path: "/login" },
  { label: "Signup", path: "/signup" },
  { label: "Client Login", path: "/clientlogin" },
  { label: "Forgot Password", path: "/forgotpassword" },
  { label: "Notifications", path: "/notifications" },
  { label: "Settings", path: "/settings" },
  { label: "Mail Settings", path: "/mailsettings" },
  { label: "Auto JRE Settings", path: "/autojresettings" },
  { label: "Purchase Auto JRE Settings", path: "/purchaseautojresettings" },
  { label: "Prefix Settings", path: "/prefixsettings" },
  { label: "Client Details", path: "/clientdetails" },

  // Dashboard
  { label: "Dashboard", path: "/index" },

  // Masters
  { label: "Masters", path: "/masters" },
  { label: "Users", path: "/users" },
  { label: "Roles", path: "/roles" },
  { label: "New Roles", path: "/newroles" },
  { label: "View Roles", path: "/viewroles" },
  { label: "Main Content", path: "/maincontent:name" },
  { label: "Super Admin Masters", path: "/superadminmasters" },
  { label: "New User", path: "/newusers" },
  { label: "Tenants", path: "/tenants" },
  { label: "New Tenant", path: "/newtenant" },
  { label: "Tenant Details", path: "/tenantdetails" },
  { label: "Screens", path: "/screens" },
  { label: "Products", path: "/products" },

  // Location Masters
  { label: "Countries", path: "/countries" },
  { label: "Add Country", path: "/addcountry" },
  { label: "Cities", path: "/cities" },
  { label: "Add City", path: "/addcity" },
  { label: "States", path: "/states" },
  { label: "Add State", path: "/addstate" },

  { label: "HSN", path: "/hsn" },
  { label: "Change Password", path: "/changepassword" },

  // Subscription
  { label: "Subscription Packs", path: "/newsubscriptionpack" },
  { label: "Subscriptions", path: "/subscriptions" },
  { label: "Subscription Pack Details", path: "/subscriptionpackdetails" },

  // Prefix
  { label: "Prefix Types", path: "/prefixtypes" },
  { label: "New Prefix Type", path: "/newprefixtype" },
  { label: "Prefixes", path: "/prefixes" },
  { label: "New Prefix", path: "/newprefix" },

  // Employees
  { label: "Employees", path: "/employees" },
  { label: "Employee Details", path: "/employeedetails" },
  { label: "New Employee", path: "/newemployee" },

  // CRM
  { label: "Customers", path: "/customers" },
  { label: "Customer Details", path: "/customerdetails" },
  { label: "New Customer", path: "/newcustomer" },
  { label: "Suppliers", path: "/suppliers" },
  { label: "New Supplier", path: "/newsupplier" },

  // Warehouse
  { label: "Warehouse", path: "/warehouse" },
  { label: "New Warehouse", path: "/newwarehouse" },

  // Work Center
  { label: "Work Center", path: "/workcenter" },
  { label: "New Work Center", path: "/newworkcenter" },

  // Category
  { label: "Category", path: "/category" },
  { label: "New Category", path: "/newcategory" },
  { label: "Category Level 2", path: "/categorylvl2" },
  { label: "New Category Level 2", path: "/newcategorylvl2" },
  { label: "Category Level 3", path: "/categorylvl3" },
  { label: "New Category Level 3", path: "/newcategorylvl3" },

  // Agents
  { label: "Agents", path: "/agents" },
  { label: "New Agent", path: "/newagent" },

  // Brand
  { label: "Brand", path: "/brand" },
  { label: "New Brand", path: "/newbrand" },

  // UOM
  { label: "UOM", path: "/uom" },
  { label: "New UOM", path: "/newuom" },

  // Size
  { label: "Size", path: "/size" },
  { label: "New Size", path: "/newsize" },

  // Colour
  { label: "Colour", path: "/colour" },
  { label: "New Colour", path: "/newcolour" },

  // Bank
  { label: "Bank", path: "/bank" },
  { label: "Add Bank", path: "/addbank" },

  // Department
  { label: "Department", path: "/department" },
  { label: "New Department", path: "/newdepartment" },

  // Transporter
  { label: "Transporter", path: "/transporter" },
  { label: "Add Transporter", path: "/addtransporter" },

  // User Customers
  { label: "User Customers", path: "/usercustomers" },
  { label: "Add User Customers", path: "/addusercustomers" },

  // Assign Type
  { label: "Assign Type", path: "/assigntype" },
  { label: "Add Assign Type", path: "/addassigntype" },

  // Tax
  { label: "Taxes", path: "/taxes" },
  { label: "Add Tax", path: "/addtax" },

  // File Service
  { label: "Download", path: "/download" },

  // Accounts
  { label: "Accounts", path: "/accounts" },
  { label: "Account Top", path: "/acctop" },
  { label: "New Account Top", path: "/newacctop" },
  { label: "Sub Accounts", path: "/subacc" },
  { label: "New Sub Account", path: "/newsubacc" },
  { label: "Sub Heads", path: "/subheads" },
  { label: "New Sub Head", path: "/newsubheads" },
// Travel
{ label: "Tour Master", path: "/tourmaster" },
{ label: "New Travel Invoice", path: "/newtravelinvoice" },
{ label: "Ticket", path: "/ticket" },
{ label: "AR Sharing", path: "/arsharing" },
{ label: "Service", path: "/service" },
{ label: "Hotel", path: "/hotel" },
{ label: "Car", path: "/car" },
{ label: "Adjustment", path: "/adjustment" },
{ label: "Hotel Or Car", path: "/hotelorcar" },

{ label: "Hotel Master", path: "/hotelMaster" },
{ label: "Hotel Master List", path: "/hotelMasterList" },
{ label: "Hotel Master Tax", path: "/hotelMastertax" },
{ label: "Hotel Master Tax List", path: "/hotelMastertaxList" },
{ label: "Hotel Master Chain", path: "/hotelMasterchain" },
{ label: "Hotel Master Chain List", path: "/hotelMasterchainlist" },
{ label: "Hotel Room Type", path: "/hotelroomtype" },
{ label: "Hotel Room Type List", path: "/hotelroomtypelist" },
{ label: "Hotel Meals Plan", path: "/hotelmealsplan" },
{ label: "Hotel Meals Plan List", path: "/hotelmealsplanlist" },

{ label: "Master Car", path: "/mastercar" },
{ label: "Master Car List", path: "/mastercarlist" },

{ label: "Master Airline", path: "/masterairline" },
{ label: "Master Airline List", path: "/masterairlinelist" },

{ label: "Master Airport", path: "/masterairport" },
{ label: "Master Airport List", path: "/masterairportlist" },

{ label: "Master Page", path: "/masterpage" },



// Sales


{ label: "Sales", path: "/sales" },

{ label: "Sales Calculation", path: "/salescal" },
{ label: "Sales Calculation Table", path: "/salescaltable" },

{ label: "Sales Invoice", path: "/salesinvoice" },
{ label: "New Sales Invoice", path: "/newsalesinvoice" },
{ label: "View Sales Invoice", path: "/viewsalesinvoice" },

{ label: "Customer Credit Note", path: "/customercreditnote" },
{ label: "Customer Credit Note Details", path: "/customercreditnotedetails" },

{ label: "Customer Debit Note", path: "/customerdebitnote" },


{ label: "Sales Direct CN DN", path: "/salesdirectcndn" },
{ label: "New Sales Direct CN DN", path: "/newsalesdirectcndn" },

{ label: "Sales Order", path: "/salesorder" },
{ label: "Sales Order Details", path: "/saleorderdetails" },
{ label: "New Sales Order", path: "/newsalesorder" },

{ label: "Delivery Note", path: "/deliverynote" },
{ label: "New Delivery Note", path: "/newdeliverynote" },
{ label: "View Delivery Note", path: "/viewdeliverynote" },

{ label: "Quotation", path: "/quotation" },
{ label: "Quotation Details", path: "/quotationdetails" },
{ label: "New Quotation", path: "/newquotation" },

{ label: "Sales Returns", path: "/salesreturns" },
{ label: "New Sale Order Return", path: "/newsaleorderreturn" },
{ label: "Sales Returns Order Details", path: "/salesreturnsorderdetails" },

{ label: "Credit Notes", path: "/creditnotes" },

{ label: "Sales Receipts", path: "/salesreceipts" },
{ label: "New Sales Receipts", path: "/newsalesreceipts" },

{ label: "Deposit Details", path: "/depositedetails" },

{ label: "Direct Trade", path: "/directtrade" },
{ label: "Two Tables", path: "/twotables" },

{ label: "New Point Of Sale", path: "/newpointofsale" },
{ label: "Point Of Sale", path: "/pointofsale" },

{ label: "New POS Price", path: "/newposprice" },
{ label: "POS Price", path: "/posprice" },
{ label: "POS Details", path: "/posdetails" },




// Purchase

{ label: "Purchase", path: "/purchase" },

{ label: "Purchase Order", path: "/purchaseorder" },
{ label: "New Purchase", path: "/newpurchase" },
{ label: "View Purchase Order", path: "/viewpurchaseorder" },

{ label: "Print", path: "/print" },

{ label: "GRN", path: "/grn" },
{ label: "New GRN", path: "/newgrn" },
{ label: "View GRN Items", path: "/viewgrnitems" },

{ label: "Purchase Returns", path: "/purchasereturns" },
{ label: "New Purchase Return", path: "/newpurchasereturn" },
{ label: "Purchase Returns Details", path: "/purchasereturnsdetails" },

{ label: "SCN", path: "/scn" },
{ label: "New SCN", path: "/newscn" },
{ label: "View SCN", path: "/viewscn" },

{ label: "Bill Of Entry", path: "/billofentry" },
{ label: "New Bill Of Entry", path: "/newbillofentry" },

{ label: "Debit Notes", path: "/debitnotes" },

{ label: "Purchase Agents Reports", path: "/purchaseagentsreports" },

{ label: "New Customer Terms", path: "/newcustomerterms" },
{ label: "Customer Terms", path: "/customerterms" },



// Reports 


{ label: "Stock Report", path: "/stockreport" },
{ label: "Inventory Report", path: "/inventoryreport" },
{ label: "Damage Report", path: "/damagereport" },
{ label: "Warehouse Report", path: "/warehousereport" },
{ label: "Consumption Report", path: "/consumptionreport" },

{ label: "Sales Report", path: "/salesreport" },
{ label: "Sale Orders Report", path: "/saleordersreport" },

{ label: "Sales Report Details", path: "/salesreportdetails" },
{ label: "Sales Report Details 2", path: "/salesreportdetails2" },

{ label: "Agents Reports", path: "/agentsreports" },

{ label: "Sales Returns Report", path: "/salesreturnsreport" },
{ label: "Sales Returns Report Details", path: "/salesreturnsreportdetails" },
{ label: "Sales Returns Report Details 2", path: "/salesreturnsreportdetails2" },

{ label: "HSN Summary", path: "/hsnsummary" },

{ label: "Overdues", path: "/overdues" },

{ label: "Purchase Report", path: "/purchasereport" },
{ label: "Purchase Report Details", path: "/purchasereportdetails" },
{ label: "Purchase Report Details 2", path: "/purchasereportdetails2" },

{ label: "Purchase Returns Report", path: "/purchasereturnsreport" },
{ label: "Purchase Returns Report Details", path: "/purchasereturnsreportdetails" },
{ label: "Purchase Returns Report Details 2", path: "/purchasereturnsreportdetails2" },




// PRooduction


{ label: "Production", path: "/production" },

{ label: "Production Templates", path: "/productiontemplates" },
{ label: "New Production Template", path: "/newproductiontemplate" },

{ label: "Immediate Production", path: "/immediateproduction" },
{ label: "New Immediate Production", path: "/newimmediateproduction" },
{ label: "Immediate Production Details", path: "/immediateproductiondetails" },

{ label: "Estimation", path: "/estimation" },
{ label: "New Estimation", path: "/newestimation" },
{ label: "Estimation Details", path: "/estimationdetails" },

{ label: "Job Order", path: "/joborder" },
{ label: "New Job Order", path: "/newjoborder" },

{ label: "Indenting", path: "/indenting" },
{ label: "New Indenting", path: "/newindenting" },
{ label: "Indenting Details", path: "/indentingdetails" },

{ label: "Indent Issue", path: "/indentissue" },
{ label: "Indent Issued Details", path: "/indentissueddetails" },

{ label: "Store", path: "/store" },
{ label: "New Store", path: "/newstore" },
{ label: "Store Details", path: "/storedetails" },

{ label: "Store Losses", path: "/storelosses" },

{ label: "Finished Products Store", path: "/finishedproductsstore" },
{ label: "Finished Products", path: "/finishedproducts" },

{ label: "In Process", path: "/inprocess" },
{ label: "New In Process", path: "/newinprocess" },

{ label: "Output Items", path: "/outputitems" },

{ label: "QA", path: "/qa" },
{ label: "New QA", path: "/newqa" },
{ label: "QA Details", path: "/qadetails" },

{ label: "Production Losses", path: "/productionlosses" },
{ label: "Production Reports", path: "/productionreports" },

{ label: "Production Process Reports", path: "/productionprocessreports" },
{ label: "Production Transaction Reports", path: "/productiontransactionreports" },
{ label: "Production Store Item Transaction Reports", path: "/productionstoreitemtransactionreports" },






// Tours & Travels Invoices
{ label: "Tour And Travels", path: "/TourAndTravels" },

{ label: "Create Flight Invoice", path: "/CreateFlightInvoice" },
{ label: "View Flight Invoice", path: "/ViewFlightInvoice" },
{ label: "Flight Invoices", path: "/FlightInvoices" },

{ label: "Hotel Invoices", path: "/HotelInvoices" },
{ label: "View Hotel Invoice", path: "/ViewHotelInvoice" },
{ label: "Create Hotel Invoice", path: "/CreateHotelInvoice" },

{ label: "Transfer Invoices", path: "/TransferInvoices" },
{ label: "View Transfer Invoice", path: "/ViewTransferInvoice" },
{ label: "Create Transfer Invoice", path: "/CreateTransferInvoice" },

{ label: "Bus Invoices", path: "/BusInvoices" },
{ label: "View Bus Invoice", path: "/ViewBusInvoice" },
{ label: "Create Bus Invoice", path: "/CreateBusInvoice" },

{ label: "Activities Invoices", path: "/ActivitiesInvoices" },
{ label: "View Activity Invoice", path: "/ViewActivityInvoice" },
{ label: "Create Activity Invoice", path: "/CreateActivityInvoice" },

{ label: "Rail Invoices", path: "/RailInvoices" },
{ label: "View Rail Invoice", path: "/ViewRailInvoice" },
{ label: "Create Rail Invoice", path: "/CreateRailInvoice" },

{ label: "Visa Invoices", path: "/VisaInvoices" },
{ label: "View Visa Invoice", path: "/ViewVisaInvoice" },
{ label: "Create Visa Invoice", path: "/CreateVisaInvoice" },

{ label: "Tour Package Invoices", path: "/TourPackageInvoices" },
{ label: "View Tour Package Invoice", path: "/ViewTourPackageInvoice" },
{ label: "Create Tour Package Invoice", path: "/CreateTourPackageInvoice" },

{ label: "Tours And Travel Invoices", path: "/ToursAndTravelInvoices" },
{ label: "View Tour And Travel Invoice", path: "/ViewTourAndTravelInvoice" },
{ label: "Create Tour And Travel Invoice", path: "/CreateTourAndTravelInvoice" },

{ label: "View Invoices", path: "/viewinvoices" },
{ label: "View Invoice Page", path: "/viewinvoicespage" },
{ label: "Sales Travel Invoice", path: "/salestravelinvoice" },

{ label: "Master List", path: "/masterlist" },
{ label: "Ticket List", path: "/ticketlist" },

{ label: "Master Partner", path: "/masterpartner" },
{ label: "Master Partner List", path: "/masterpartnerlist" },

// Project Management
{ label: "Project Management", path: "/projectmanagement" },
{ label: "Projects", path: "/projects" },
{ label: "Project Details", path: "/project/:id" },
{ label: "New Project", path: "/newproject" },

{ label: "Add Site", path: "/addsite" },
{ label: "Add Project Manager", path: "/addprojectmanager" },
{ label: "Assign Client", path: "/assignclient" },
{ label: "Add Site Incharge", path: "/addsiteincharge" },

{ label: "Project Estimation", path: "/projectestimation" },
{ label: "New Project Estimation", path: "/newprojectestimation" },
{ label: "Project Estimation Details", path: "/projectestimation/:id" },

{ label: "Project Dashboard", path: "/projectdashboard" },

{ label: "Labours", path: "/Labours" },
{ label: "Add Labour", path: "/AddLabour" },

{ label: "Project Indenting", path: "/projectindenting" },
{ label: "New Project Indenting", path: "/newprojectindenting" },

{ label: "Project Store Items", path: "/projectstoreitems" },
{ label: "Project Store Table", path: "/projectstoretable" },
{ label: "Project Store New Item", path: "/projectstorenewitem" },
 
];